var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0,0H13V13H0Z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon",
    d: "M2.533,3h9.6a.531.531,0,0,1,.533.528v8.444a.531.531,0,0,1-.533.528h-9.6A.531.531,0,0,1,2,11.972V3.528A.531.531,0,0,1,2.533,3ZM7.365,7.583,3.946,4.709l-.691.8,4.117,3.46,4.043-3.462-.7-.8L7.366,7.583Z",
    transform: "translate(-0.833 -1.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.b8e31a13dfe70be3bb6603253fcb9d61.svg";
export { ForwardRef as ReactComponent };